<template>
  <div class="tenancyDepositRelease">
    <h2>{{ defaultHeader }}</h2>

    <InfoCard class="mt-5">
      Hvis leietaker ikke besvarer avslutningen innen 30 dager så må avslutningen
      startes på nytt
    </InfoCard>

    <BlockContainer class="p-5 mt-4">
      <router-view />
    </BlockContainer>
  </div>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
import InfoCard from '@/components/InfoCard.vue';

export default {
  props: {
    defaultHeader: {
      type: String,
      required: true,
    },
  },
  components: {
    BlockContainer,
    InfoCard,
  },
};
</script>
